import DialogChain from '../../dialogs/DialogChain'
import HelpOption from './HelpOption'
import HelpFeedback from '../HelpFeedback'
import OptionScore from './OptionScore'
import HelpOptionActions from './HelpOptionActions'


export default function HelpOptions(props){
  const titles = ["Options", "Option Score", "Option Actions", "Sharing Feedback"]
  const helpDialogs = [HelpOption, OptionScore, HelpOptionActions,HelpFeedback]

  return (
    <DialogChain
      titles={titles}
      dialogs={helpDialogs}
      handleClose={props.handleClose}
      open={props.open}/>
  );


}
